import { IntlShape } from "react-intl";
import { TableColumns } from "../shared/crud/list";
import { EngineMultiConfigEntity } from "./domain/engineMultiConfig.entity";
import { mapRenderer, StringRenderer } from "../shared/renderers/table";

export default function getTableColumns(intl: IntlShape): TableColumns<EngineMultiConfigEntity> {
  return {
    id: {
      renderer: StringRenderer,
    },
    ticker: {
      renderer: StringRenderer,
    },
    triggersList: {
      renderer: mapRenderer(StringRenderer, (v) => {
        return v.join(", ");
      }),
    }
  }
}